import { render, staticRenderFns } from "./UnitCodeDetail.vue?vue&type=template&id=14902dd4&scoped=true"
import script from "./UnitCodeDetail.vue?vue&type=script&lang=js"
export * from "./UnitCodeDetail.vue?vue&type=script&lang=js"
import style0 from "./UnitCodeDetail.vue?vue&type=style&index=0&id=14902dd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14902dd4",
  null
  
)

export default component.exports